var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var KeyboardArrowDownIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", d: "M11.2626407,15.1768542 L6.31289322,10.2271068 C5.92236893,9.83658249 5.92236893,9.20341751 6.31289322,8.81289322 C6.70341751,8.42236893 7.33658249,8.42236893 7.72710678,8.81289322 L11.994,13.08 L16.2626407,8.81289322 C16.653165,8.42236893 17.28633,8.42236893 17.6768542,8.81289322 C18.0673785,9.20341751 18.0673785,9.83658249 17.6768542,10.2271068 L12.7271068,15.1768542 C12.5468648,15.3570962 12.314936,15.4541496 12.0790314,15.4680144 L11.9107161,15.4680144 C11.6748114,15.4541496 11.4428827,15.3570962 11.2626407,15.1768542 Z" }))); };
export default KeyboardArrowDownIcon;
